/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const LogoutIcon = createIcon({
    displayName: 'LogoutIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "M5.63 17.67c-.18-1.7-.31-3.83-.3-6.04.01-1.99.13-3.77.29-5.3h6.76c.12.97.2 2.12.24 3.34h1.33c-.05-1.47-.15-2.84-.3-3.95-.05-.42-.3-.72-.59-.72H4.94c-.29 0-.55.3-.6.73-.18 1.66-.33 3.65-.34 5.9-.01 2.46.14 4.84.36 6.65.05.42.3.72.59.72h8.12c.3 0 .55-.3.59-.72.15-1.13.25-2.5.3-3.95h-1.33c-.04 1.21-.12 2.36-.23 3.34H5.63Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "m16.98 8.457-.008-.007a24.845 24.845 0 0 1-.332-.285l-.878 1.003c.153.133.256.22.348.298l.008.006c.135.115.243.207.462.408.584.539 1.018.956 1.505 1.45H10v1.33h8.085c-.486.494-.92.911-1.505 1.45-.224.206-.332.297-.472.415-.09.077-.194.165-.346.297l.878 1.003.33-.284c.153-.129.27-.228.514-.453a41.932 41.932 0 0 0 2.096-2.055 1.497 1.497 0 0 0 0-2.076 42.262 42.262 0 0 0-2.096-2.055c-.24-.22-.357-.32-.504-.445Z"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M3.4 20c-.25-2.4-.42-5.41-.4-8.52.01-2.81.17-5.32.39-7.49h9.22c.11.92.19 1.93.25 3.01h2c-.08-1.46-.2-2.81-.35-3.97-.07-.6-.42-1.03-.83-1.03H2.31c-.41 0-.76.43-.83 1.04A82.31 82.31 0 0 0 1 11.47c-.02 3.52.2 6.92.5 9.5.07.6.42 1.03.83 1.03H13.7c.41 0 .76-.43.84-1.03.15-1.17.26-2.52.34-3.97h-2a58.18 58.18 0 0 1-.24 3H3.4Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M19.226 7.352c-.36-.333-.537-.482-.76-.671l-.008-.007c-.13-.111-.28-.237-.498-.429l-1.317 1.506c.23.2.385.332.521.448l.015.013c.202.17.364.309.69.61a61.195 61.195 0 0 1 2.258 2.176H9v2h11.127c-.73.741-1.38 1.367-2.257 2.176-.337.31-.498.447-.708.625-.136.115-.29.247-.519.446l1.317 1.506.496-.427c.228-.193.404-.343.77-.68a62.98 62.98 0 0 0 3.144-3.087 2.25 2.25 0 0 0 0-3.118 63.378 63.378 0 0 0-3.144-3.087Z"
        })
    ]
});
LogoutIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'LogoutIcon'
};
export { LogoutIcon };

//# sourceMappingURL=logout.js.map